var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',_vm._b({attrs:{"color":_vm.color}},'v-icon',_vm.$attrs,false),[_vm._v(_vm._s(_vm.iconPath))])
}
var staticRenderFns = []

export { render, staticRenderFns }